import $ from 'jquery';

export const init = () => {

	$(document)
		.on('click', '.b-cookie .btn', function(e) {
			e.preventDefault();

			var date = new Date();

			date.setFullYear(date.getFullYear() + 10);
			document.cookie = 'eu-cookies=1; path=/; expires=' + date.toGMTString();

			$('.b-cookie').fadeOut();
		});

	// skrytí cookie lišty – lepší je dělat přímo v PHP či Latte – lišta pak nečeká na inicializaci JS
	if ( document.cookie.includes('eu-cookies=1') ){
		$('.b-cookie').hide();
	};

};



// WEBPACK FOOTER //
// ./src/js/components/cookie.js